__turbopack_context__.v({
  "actions": "FavoriteDialogs-module-scss-module__2GqbbW__actions",
  "body": "FavoriteDialogs-module-scss-module__2GqbbW__body",
  "date": "FavoriteDialogs-module-scss-module__2GqbbW__date",
  "dialog": "FavoriteDialogs-module-scss-module__2GqbbW__dialog",
  "note": "FavoriteDialogs-module-scss-module__2GqbbW__note",
  "primary": "FavoriteDialogs-module-scss-module__2GqbbW__primary",
  "reason": "FavoriteDialogs-module-scss-module__2GqbbW__reason",
  "reasonIcon": "FavoriteDialogs-module-scss-module__2GqbbW__reasonIcon",
  "reasons": "FavoriteDialogs-module-scss-module__2GqbbW__reasons",
  "secondary": "FavoriteDialogs-module-scss-module__2GqbbW__secondary",
  "text": "FavoriteDialogs-module-scss-module__2GqbbW__text",
  "title": "FavoriteDialogs-module-scss-module__2GqbbW__title",
});
